var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 170.80097884834709,
    height: 174.21255962949078,
    viewBox: "746.3495105758266 -242.5062798147454 170.80097884834709 174.21255962949078",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.37 0 0 0.59 831.67 -135.83)",
    id: "0RAGRxPq5TX470i1xFhfr"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -64.32 -24.9)",
    x1: 68.10810810810813,
    y1: -5.37168248643426,
    x2: 65.94594070327997,
    y2: 50.84453372978199
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FE9AC0",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#F759F2",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(95,140,204)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_9)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 0 -24.89859 C 35.50703 -24.89859 64.32432 3.78003 64.32432 18.400570000000002 C 64.32432 33.02111 35.50702 18.400570000000002 0 18.400570000000002 C -35.50703 18.400570000000002 -64.32432 33.02111 -64.32432 18.400570000000002 C -64.32432 3.7800300000000018 -35.50702 -24.89859 0 -24.89859 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.47 0.21 -0.41 0.91 797.05 -155.4)",
    id: "riTyOuD0_-pP-qhjECR09"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -31.89 -88.11)",
    x1: 36.45606484158837,
    y1: -4.542726170865237,
    x2: 32.31377528377584,
    y2: 175.49277699872954
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FFA7B6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54.80177974391568%",
    style: {
      stopColor: "#F654F6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#FFFF9E",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(166,111,27)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_35)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 0 -88.10811 C 17.60432 -88.10811 31.89189 -48.635679999999994 31.89189 0 C 31.89189 48.63568 17.60432 88.10811 0 88.10811 C -17.60432 88.10811 -31.89189 48.635679999999994 -31.89189 0 C -31.89189 -48.63568 -17.60432 -88.10811 0 -88.10811 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.47 0.21 0.41 0.91 866.46 -155.4)",
    id: "2Assj-ZRQjPMvwPEJzXea"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -31.89 -88.11)",
    x1: 36.45606484158837,
    y1: -4.542726170865237,
    x2: 32.31377528377584,
    y2: 175.49277699872954
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FFA7B6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54.80177974391568%",
    style: {
      stopColor: "#F654F6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#FFFF9E",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(166,111,27)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_36)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 0 -88.10811 C 17.60432 -88.10811 31.89189 -48.635679999999994 31.89189 0 C 31.89189 48.63568 17.60432 88.10811 0 88.10811 C -17.60432 88.10811 -31.89189 48.635679999999994 -31.89189 0 C -31.89189 -48.63568 -17.60432 -88.10811 0 -88.10811 z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.6b46dfa4aaf440ee5919d7d787598f90.svg";
export { ForwardRef as ReactComponent };